import { useMemo } from 'react';
import { generatePath } from 'react-router';
import { useQuery } from '@tanstack/react-query';

import type { components } from 'src/types/allApiTypes.gen';
import type { ModuleOrPlanActionOrgUnit } from 'src/types/orgUnit';
import { apiPaths } from 'src/services/api/apiPaths';
import HttpService from 'src/services/api/http';

export const ORG_UNIT_BY_SURVEY_PAGINATION_LIMIT = 50;

export type PaginatedOrgUnitList = Omit<
  components['schemas']['PaginatedOrganisationalUnitList'],
  'results'
> & {
  results: ModuleOrPlanActionOrgUnit[];
};

export const useOrgUnitBySurveyQuery = (
  surveyId: number | undefined,
  moduleId: number | undefined,
) => {
  const endpoint = useMemo(
    () =>
      surveyId
        ? generatePath(apiPaths.ORG_UNIT_BY_SURVEY, {
            surveyId,
          })
        : 'placeholder-will-never-be-called',
    [surveyId],
  );

  return useQuery<PaginatedOrgUnitList>({
    queryKey: [endpoint, moduleId],
    queryFn: ({ signal }) =>
      HttpService.get(
        endpoint,
        {
          module_id: moduleId,
          only_assigned: true,
          limit: ORG_UNIT_BY_SURVEY_PAGINATION_LIMIT,
        },
        false,
        { signal },
      )
        .then((data) => Promise.resolve(data.data))
        .catch(({ response }) => Promise.reject(response.status)),
    enabled: !!surveyId,
  });
};
